import { mapEnumToOptions } from '@abp/ng.core';

export enum ReportFrequency {
  None = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export const reportFrequencyOptions = mapEnumToOptions(ReportFrequency);
